<template>
  <div>
    <div class="row">
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper">
          <label>Ethnicity</label>
          <el-select
              v-model="filters.demographics.ethnicity.value" collapse-tags
              placeholder="Select values" @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getDemographicsTagValues('ethnicity')"
                  :key="value" :label="value" :value="value">
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Gender</label>
          <el-select
              v-model="filters.demographics.gender.value" @change="updateDropdownValues()"
              placeholder="Select values" collapse-tags
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getDemographicsTagValues('gender')"
                  :key="value" :label="value" :value="value">
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper" style="padding-bottom: 17px">
          <label>Age</label>
          <div class="slider-wrapper">
            <vue-slider
              v-if="Object.keys(ageInput).length"
              v-model="ageInput.value"
              range
              :marks="ageInput.marks"
              :min="ageInput.min"
              :max="ageInput.max"
              :process="ageSliderProcess"
              tooltip="none"
              included
              @change="parseAge()"
            >
            </vue-slider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
export default {
  name: 'DemographicsForm',
  components: {
    VueSlider
  },
  props: {
    filters: Object,
    getDemographicsTagValues: Function,
    updateDropdownValues: Function
  },
  data () {
    return {
      ageInput: {
        min: 0,
        max: 100,
        value: [
          Number(this.filters.demographics.startAge.value) || 0,
          Number(this.filters.demographics.endAge.value) || 100
        ],
        bins: [],
        marks: {
          0: '0',
          18: '18',
          30: '30',
          40: '40',
          50: '50',
          65: '65',
          100: '100'
        },
        includeMissing: true
      },
      ageBins: [
        0, 18, 30, 40, 50, 65, 100
      ],
      ageSliderProcess: dotsPos => [
        [dotsPos[0], dotsPos[1], {
          backgroundColor: '#962292',
          height: '6px',
          transform: 'translate(0px, -1px)'
        }]
      ],
      ageStep: 10,
      socialClassInputValue: ''
    }
  },
  methods: {
    parseAge () {
      this.filters.demographics.startAge.value = this.ageInput.value[0]
      this.filters.demographics.endAge.value = this.ageInput.value[1]
    },
    clearAgeInput () {
      this.$set(this.ageInput, 'value', [this.ageInput.min, this.ageInput.max])
      this.filters.demographics.startAge.value = ''
      this.filters.demographics.endAge.value = ''
    },
    clearSocialClass () {
      this.socialClassInputValue = ''
    },
    setSocialClass (data) {
      this.socialClassInputValue = data
    }
  },
  mounted () {
    // console.log(this.filters)
    // if (this.filters.demographics.socialClass.value) {
    //   this.socialClassInputValue = this.getDemographicsTagValues('social_class').find(el => el.value === this.filters.demographics.socialClass.value).label
    // }
  },
  watch: {
    socialClassInputValue (newData) {
      if (newData) {
        const test = this.getDemographicsTagValues('social_class').find(el => el.label === newData).value
        this.$set(this.filters.demographics.socialClass, 'value', test)
      } else {
        this.$set(this.filters.demographics.socialClass, 'value', '')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables";

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.input-wrapper label {
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
}

.slider-wrapper {
  width: 92%;
  margin: 2px auto 0;
}
</style>
